module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-email-89453760669af923a4c67b0c9aded8bb.png";